import React, { useState, useEffect } from "react";
import { Modal } from "@mui/material";
import { RxCross1 } from "react-icons/rx";
import { toast } from "react-toastify";
import { HttpService } from "../../service/HttpService";
import dayjs from "dayjs";

const MatricIdsListModal = ({ open, handleClose, row }) => {
  const [matricList, setMatricList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const httpService = new HttpService();

  useEffect(() => {
    if (!open) {
      setSearchQuery("");
    }
  }, [open]);

  useEffect(() => {
    if (!open || !row) return;

    // Helper to safely parse JSON or array
    const getSelectedMatricArray = (val) => {
      if (!val) return null;
      if (Array.isArray(val)) return val;
      if (typeof val === "string") {
        try {
          const parsed = JSON.parse(val);
          if (Array.isArray(parsed)) return parsed;
        } catch (e) {
          return null;
        }
      }
      return null;
    };

    const rawSelected = getSelectedMatricArray(row.selected_matric_ids);
    if (rawSelected && rawSelected.length > 0) {
      const formattedList = rawSelected.map((item, idx) => {
        if (typeof item === "string" || typeof item === "number") {
          return { id: idx, matric_id: String(item) };
        }
        return {
          id: item.id || idx,
          matric_id:
            item.matric_id || item.matric_code || item.tag || String(item),
        };
      });
      setMatricList(formattedList);
      setLoading(false);
      return;
    }

    const fetchMatricIds = async () => {
      const cultivarId = row.cultivar_id;
      const roomId = row.room_id;
      const harvestDate = row.harvest_date
        ? dayjs(row.harvest_date).format("YYYY-MM-DD")
        : "";

      if (!cultivarId || !roomId || !harvestDate) {
        toast.error(
          "Required fields (Cultivar, Room, Harvest Date) are missing for this record.",
        );
        handleClose();
        return;
      }

      setLoading(true);
      try {
        const res = await httpService.get(
          `harvest/plant-count-with-matric?plantId=${cultivarId}&roomId=${roomId}&harvestedDate=${harvestDate}`,
        );
        if (res?.data) {
          setMatricList(res.data.matric_ids || []);
        } else {
          setMatricList([]);
        }
      } catch (e) {
        console.error(e);
        setMatricList([]);
      }
      setLoading(false);
    };

    fetchMatricIds();
  }, [open, row]);

  const filteredList = matricList.filter((item) =>
    (item.matric_id || "").toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="matric-modal-title"
    >
      <div
        className="modal_block"
        style={{ width: "90%", maxWidth: 500, boxSizing: "border-box" }}
      >
        <div className="modal_header">
          <div className="modal_title_wrapper">
            <h2 className="modal_title" id="matric-modal-title">
              Matric IDs
            </h2>
          </div>
          <div className="cancel-btn-wrap">
            <RxCross1 onClick={handleClose} style={{ cursor: "pointer" }} />
          </div>
        </div>
        <div
          className="modal_content"
          style={{
            maxHeight: "450px",
            overflowY: "auto",
            padding: "16px 24px",
          }}
        >
          {/* Search Input */}
          <div style={{ marginBottom: "16px", position: "relative" }}>
            <input
              type="text"
              placeholder="Search Matric IDs..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 40px 10px 14px",
                fontSize: "14px",
                border: "1px solid #ced4da",
                borderRadius: "6px",
                outline: "none",
                transition: "border-color 0.15s ease-in-out",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#00A272")}
              onBlur={(e) => (e.target.style.borderColor = "#ced4da")}
            />
            {searchQuery && (
              <RxCross1
                onClick={() => setSearchQuery("")}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#6c757d",
                  fontSize: "16px",
                }}
              />
            )}
          </div>

          {loading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              Loading Matric IDs...
            </div>
          ) : matricList.length === 0 ? (
            <div
              style={{ textAlign: "center", padding: "20px", color: "#666" }}
            >
              No Matric IDs found for this package.
            </div>
          ) : filteredList.length === 0 ? (
            <div
              style={{ textAlign: "center", padding: "20px", color: "#666" }}
            >
              No matching Matric IDs found.
            </div>
          ) : (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {filteredList.map((item, idx) => (
                <div
                  key={item.id || idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 14px",
                    background: "#f8f9fa",
                    borderRadius: "6px",
                    border: "1px solid #e9ecef",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ fontWeight: 500, color: "#495057" }}>
                    {/* {idx + 1}.  */}
                    {item.matric_id || "N/A"}
                  </span>
                  {/* <button
                    type="button"
                    style={{
                      background: "none",
                      border: "none",
                      color: "#00A272",
                      cursor: "pointer",
                      fontSize: "12px",
                      fontWeight: 600,
                    }}
                    onClick={() => {
                      navigator.clipboard.writeText(item.matric_id);
                      toast.success("Copied to clipboard!");
                    }}
                  >
                    Copy
                  </button> */}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MatricIdsListModal;
